import { Indicator } from "../proto/generated/indicator"

export const getIndicatorDisplayName = (indicator: Indicator, config: Record<string, string>): string => {
    let name = indicator.shortName || indicator.code;

    if (indicator.inputs.length) {
        name += " (";
        const inputs = indicator.inputs.map((input) => config[input.code]).filter(v => v)

        name += `${inputs.join(", ")})`
    }

    return name;

}

export const sanitizeId = (param: string) => param.replace(/\W+/g, "_").toUpperCase()